import { doc, onSnapshot, type Unsubscribe } from "firebase/firestore";
import { httpsCallable } from "firebase/functions";

import { db, functions } from "./firebase";
import type { UserCredits } from "../types/user";

export function subscribeUser(
  uid: string,
  onUpdate: (user: UserCredits | null) => void,
): Unsubscribe {
  const userRef = doc(db, "users", uid);
  return onSnapshot(userRef, (snapshot) => {
    if (!snapshot.exists()) {
      onUpdate(null);
      return;
    }
    onUpdate(snapshot.data() as UserCredits);
  });
}

export async function ensureUser(): Promise<void> {
  const callable = httpsCallable(functions, "ensureUser");
  await callable();
}
